module.exports = __webpack_public_path__ + "img/img34.511c1f59.png";